
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24.001"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"그룹 2047","transform":"translate(-1123.501 -636.936)"}},[_c('g',{attrs:{"data-name":"그룹 2047"}},[_c('rect',{attrs:{"data-name":"사각형 2745","width":"24","height":"24","rx":"5","transform":"translate(1123.501 636.937)","fill":"#fff"}}),_c('path',{attrs:{"data-name":"패스 1234","d":"M1142.5 638.936a3 3 0 013 3v14a3 3 0 01-3 3h-14a3 3 0 01-3-3v-14a3 3 0 013-3h14m0-2h-14a5.015 5.015 0 00-5 5v14a5.015 5.015 0 005 5h14a5.015 5.015 0 005-5v-14a5.015 5.015 0 00-5-5z"}})]),_c('circle',{attrs:{"data-name":"타원 256","cx":"2","cy":"2","r":"2","transform":"translate(1139.501 640.937)"}}),_c('path',{attrs:{"data-name":"패스 1235","d":"M1135.71 652.958a1.861 1.861 0 01-.21-.012 2.3 2.3 0 01-1.788-1.351l-2.211-4.422a1.34 1.34 0 00-.06-.106c-.019.029-.042.062-.064.1l-3.008 5.264a1 1 0 11-1.736-.993l3.008-5.263a2.129 2.129 0 011.81-1.205h.049a2.118 2.118 0 011.79 1.3l2.211 4.422c.1.2.191.253.211.258s.12-.036.257-.208l1.5-1.877a2.8 2.8 0 012.023-1.06 2.762 2.762 0 012.128.831l2.586 2.585a1 1 0 01-1.414 1.415l-2.586-2.586a.745.745 0 00-.6-.249.792.792 0 00-.571.314l-1.5 1.877a2.357 2.357 0 01-1.825.966z"}})])])
          )
        }
      }
    